import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import "./phone-field.css";

export { isValidPhoneNumber };

export function PhoneField({ value, onChange, placeholder = "Phone number", testId, autoFocus }) {
  return (
    <div className="phone-field" data-testid={testId ? `${testId}-wrap` : undefined}>
      <PhoneInput
        international
        defaultCountry="IN"
        countryCallingCodeEditable={false}
        addInternationalOption={false}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        autoFocus={autoFocus}
        numberInputProps={{
          className: "phone-field__input",
          "data-testid": testId,
          required: true,
        }}
      />
    </div>
  );
}
